module.exports = __webpack_public_path__ + "img/03.78ff28d4.jpg";